import type { FileDownloadBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface FileDownloadBlockEditorProps {
  content: FileDownloadBlockContent | null
  onChange: (content: FileDownloadBlockContent) => void
}

export function FileDownloadBlockEditor({
  content,
  onChange,
}: FileDownloadBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<FileDownloadBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">File Download</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Label</Label>
          <Input
            value={c.label ?? ""}
            onChange={(e) => update({ label: e.target.value })}
            placeholder="Download PDF"
          />
        </div>
        <div>
          <Label>File URL</Label>
          <Input
            value={c.url ?? ""}
            onChange={(e) => update({ url: e.target.value })}
            placeholder="https://..."
          />
        </div>
        <div>
          <Label>Description (optional)</Label>
          <Textarea
            value={c.description ?? ""}
            onChange={(e) => update({ description: e.target.value })}
            placeholder="Brief description"
            rows={2}
            className="resize-none"
          />
        </div>
        <div>
          <Label>File Type (optional)</Label>
          <Input
            value={c.file_type ?? ""}
            onChange={(e) => update({ file_type: e.target.value })}
            placeholder="PDF"
          />
        </div>
        <div>
          <Label>File Size (optional)</Label>
          <Input
            value={c.file_size ?? ""}
            onChange={(e) => update({ file_size: e.target.value })}
            placeholder="2.5 MB"
          />
        </div>
      </CardContent>
    </Card>
  )
}
